var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallInactiveCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "#BFBFBF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4663 4.79961C12.1997 4.53294 11.7997 4.53294 11.533 4.79961L6.53301 9.79961L4.46634 7.73294C4.19967 7.46628 3.79967 7.46628 3.53301 7.73294C3.26634 7.99961 3.26634 8.39961 3.53301 8.66628L6.06634 11.1996C6.19967 11.3329 6.33301 11.3996 6.53301 11.3996C6.73301 11.3996 6.86634 11.3329 6.99967 11.1996L12.4663 5.73294C12.733 5.46628 12.733 5.06628 12.4663 4.79961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallInactiveCheckbox);
export default __webpack_public_path__ + "static/media/smallInactiveCheckbox.b151577ca067295be1f77d645ebf9f71.svg";
export { ForwardRef as ReactComponent };